'use client'

import cn from 'clsx'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { Link } from '../link'
import s from './button.module.css'

const Glyph0 = dynamic(() => import('~/assets/svgs/glyph0.svg'))
const Glyph1 = dynamic(() => import('~/assets/svgs/glyph1.svg'))
const Glyph2 = dynamic(() => import('~/assets/svgs/glyph2.svg'))
const Glyph3 = dynamic(() => import('~/assets/svgs/glyph3.svg'))
const Glyph4 = dynamic(() => import('~/assets/svgs/glyph4.svg'))
const Glyph5 = dynamic(() => import('~/assets/svgs/glyph5.svg'))
const Glyph6 = dynamic(() => import('~/assets/svgs/glyph6.svg'))
const Glyph7 = dynamic(() => import('~/assets/svgs/glyph7.svg'))
const Glyph8 = dynamic(() => import('~/assets/svgs/glyph8.svg'))
const Glyph9 = dynamic(() => import('~/assets/svgs/glyph9.svg'))
const Glyph10 = dynamic(() => import('~/assets/svgs/glyph10.svg'))
const Glyph11 = dynamic(() => import('~/assets/svgs/glyph11.svg'))
const Glyph12 = dynamic(() => import('~/assets/svgs/glyph12.svg'))
const Glyph13 = dynamic(() => import('~/assets/svgs/glyph13.svg'))

export function Glyphs({ className, _active, isReversed = false }) {
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (isReversed) {
          return prevIndex === 0 ? 13 : prevIndex - 1
        }
        return (prevIndex + 1) % 13
      })
    }, 100)

    return () => clearInterval(interval)
  }, [isReversed])

  return (
    <div
      className={cn(
        'absolute sw-10 sh-10 top-[50%] translate-y-[-50%] sleft-8',
        s.glyphs,
        className
      )}
    >
      <Glyph13 className={cn(currentIndex !== 0 && 'invisible')} />
      <Glyph0 className={cn(currentIndex !== 1 && 'invisible')} />
      <Glyph1 className={cn(currentIndex !== 2 && 'invisible')} />
      <Glyph2 className={cn(currentIndex !== 3 && 'invisible')} />
      <Glyph3 className={cn(currentIndex !== 4 && 'invisible')} />
      <Glyph4 className={cn(currentIndex !== 5 && 'invisible')} />
      <Glyph5 className={cn(currentIndex !== 6 && 'invisible')} />
      <Glyph6 className={cn(currentIndex !== 7 && 'invisible')} />
      <Glyph7 className={cn(currentIndex !== 8 && 'invisible')} />
      <Glyph8 className={cn(currentIndex !== 9 && 'invisible')} />
      <Glyph9 className={cn(currentIndex !== 10 && 'invisible')} />
      <Glyph10 className={cn(currentIndex !== 11 && 'invisible')} />
      <Glyph11 className={cn(currentIndex !== 12 && 'invisible')} />
      <Glyph12 className={cn(currentIndex !== 13 && 'invisible')} />
    </div>
  )
}

export function Button({
  children,
  className,
  href,
  arrow = true,
  icon = false,
  ...props
}) {
  const isExternal = href?.startsWith('http') || href?.startsWith('//')

  const Tag = href ? Link : 'button'

  return (
    <Tag
      className={cn(
        s.button,
        'cta bg-contrast relative flex items-center justify-between spx-8 spy-8 dt:spy-4 ',
        className
      )}
      {...props}
      {...(href && { href })}
    >
      <Glyphs
        className={cn(
          'absolute sw-10 sh-10 top-[50%] translate-y-[-50%] sleft-8 desktop-only',
          s.glyphs
        )}
      />
      <span className={s.inner}>{children}</span>
      {arrow && <span>{isExternal ? '↗' : '→'}</span>}
      {icon && icon}
    </Tag>
  )
}
